var assign = require('object-assign');
var transform = function (exception, options) {
    exception = assign(exception, {});
    return exception;
};
export default {
    transform: transform
};
